<template>
  <base-data-table
    :items="externalLinks"
    title="外部リンク"
    header-icon="mdi-open-in-new"
    :column-widths="['220px', '160px', '', '120px']"
  >
    <template #header-actions>
      <v-btn
        color="#3ACAC9"
        variant="flat"
        size="small"
        prepend-icon="mdi-plus"
        class="text-white"
        @click="$emit('add-link')"
      >
        新規登録
      </v-btn>
    </template>
    <template #header-cells>
      <th>タイトル</th>
      <th>登録日時</th>
      <th>URL</th>
      <th />
    </template>
    <template #cells="{ row: externalLink }">
      <td>
        <div class="base-data-table-two-line-clamp">{{ externalLink.title }}</div>
      </td>
      <td>{{ externalLink.registeredAt }}</td>
      <td>
        <a
          :href="externalLink.url"
          target="_blank"
          rel="noopener noreferrer"
          class="base-data-table-link base-data-table-two-line-clamp"
        >
          {{ externalLink.url }}
        </a>
      </td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          @click="$emit('open-detail', externalLink)"
        >
          詳細を開く
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";

export default {
  name: "FaceSheetExternalLinksTable",
  components: {
    BaseDataTable
  },
  props: {
    externalLinks: {
      type: Array,
      default: () => []
    }
  },
  emits: ["add-link", "open-detail"]
};
</script>
